import EventBus from '@/eventBus'

export default {
  handleAIGenerateSlideEvent(doc) {
    EventBus.$emit('slide-generator:generated', doc)
  },
  handleAIResponseCreatedEvent(doc) {
    EventBus.$emit('slide-generator: ai_response_created', doc)
  },
  handleAIGenerateTemplateDescription(doc) {
    EventBus.$emit('ai-template-description: generated', doc)
  },
  handleAIGenerateWordCloudSmartGrouping(doc) {
    EventBus.$emit('word-cloud-smart-grouping: generated', doc)
  },
}
